import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const NotFound: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-24">
      <div className="text-center max-w-md">
        <p className="text-sm font-semibold text-brand-600">404</p>
        <h1 className="mt-2 text-title-lg text-content sm:text-display text-balance">
          We couldn't find that page
        </h1>
        <p className="mt-4 text-content-muted">
          The link may be out of date, or the page may have moved.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to={isAuthenticated ? '/dashboard' : '/'} className="btn-primary px-6 py-3">
            {isAuthenticated ? 'Back to dashboard' : 'Back to home'}
          </Link>
          {isAuthenticated && (
            <Link
              to="/opportunities"
              className="text-sm font-semibold text-brand-600 hover:text-brand-700"
            >
              Browse opportunities &rarr;
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
